import store from "@/state/store";
import Layout from "@/views/layouts/main";
import AuthLayout from "@/views/layouts/auth";

export default [
  {
    path: "/",
    redirect: "/dashboard",
  },
  {
    path: "/login",
    name: "Login",
    meta: {
      authRequired: false,
      authorize: null,
      layout: AuthLayout,
    },
    component: () => import("@/views/auth/login"),
  },
  {
    path: "/logout",
    name: "Logout",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
      beforeResolve(routeTo, routeFrom, next) {
        store.dispatch("auth/logout");
        next("/login");
      },
    },
  },
  {
    path: "/dashboard",
    name: "Default",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/dashboard"),
  },
  {
    path: "/up-sell",
    name: "Up Sell",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/upSell"),
  },
  {
    path: "/up-sell-order",
    name: "Up Sell Order",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/upSell/order"),
  },
  {
    path: "/maintenance-request",
    name: "Maintenance Request",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/maintenanceRequest"),
  },
  {
    path: "/maintenance-requests-list",
    name: "MR List",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/maintenanceRequest/requests.vue"),
  },
  {
    path: "/main-req-logs",
    name: "Req. Logs",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/maintenanceRequest/reqLog.vue"),
  },
  {
    path: "/booking",
    name: "Booking",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/booking/booking"),
  },
  {
    path: "/booking/kiosk",
    name: "Kiosk Booking",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/booking/KioskBooking"),
  },
  {
    path: "/booking-filter",
    name: "Booking Filter",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/booking-filter.vue"),
  },
  {
    path: "/SyncHistory",
    name: "Sync History",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/booking/SyncHistory"),
  },
  {
    path: "/booking/audit",
    name: "Booking Audit",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/audit/index"),
  },
  {
    path: "/booking/audit/night",
    name: "Booking Night Audit",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/audit/nightAudit"),
  },
  {
    path: "/guest",
    name: "Guest",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/guest/guest"),
  },
  {
    path: "/company",
    name: "Company",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/company/company"),
  },
  {
    path: "/hotel",
    name: "Hotel",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/hotel/hotel"),
  },
  {
    path: "/additional-fields",
    name: "Additional Fields",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/hotel/additionalFields/"),
  },
  {
    path: "/hotel-directory",
    name: "Hotel Directory",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/hotel/infoServices/hotelDetails.vue"),
  },
  {
    path: "/room-info",
    name: "My Room",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/hotel/infoServices/roomDetails.vue"),
  },
  {
    path: "/near-by-place",
    name: "Near By Place",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/hotel/nearByPlace/"),
  },
  {
    path: "/tv-channel",
    name: "Tv Channel",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/hotel/tvChannel/"),
  },
  {
    path: "/local-event",
    name: "Local Event",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/hotel/localEvent/"),
  },
  {
    path: "/account-setup",
    name: "Account Setup",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/accountSetup/"),
  },
  {
    path: "/kiosk-machine-setting",
    name: "kiosk Machine Setting",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/kioskMachineSetting/"),
  },
  {
    path: "/kiosk-machine-setting/:id",
    name: "Edit kiosk Machine Setting",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/kioskMachineSetting/form"),
  },
  {
    path: "/role",
    name: "Role",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/staffPermission/role"),
  },
  {
    path: "/staff",
    name: "Staff",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/staffPermission/staff"),
  },
  {
    path: "/room-type",
    name: "Room Type",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/inventory/roomType"),
  },
  {
    path: "/buildings",
    name: "Building",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/inventory/building"),
  },
  {
    path: "/floor-plan",
    name: "Floor Plan",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/inventory/floor"),
  },
  {
    path: "/bed-type",
    name: "Bed Type",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/inventory/bed"),
  },
  {
    path: "/rooms",
    name: "Room",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/inventory/room"),
  },
  {
    path: "/rooms-availability",
    name: "Room Availability",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/inventory/roomAvailability"),
  },
  {
    path: "/rate-plan",
    name: "Rate plan",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/inventory/ratePlan"),
  },
  {
    path: "/rate-plan/:id",
    name: "Rate Plan Detail",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/inventory/ratePlanDetail"),
  },
  {
    path: "/email-templates",
    name: "Email Template",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/preferences/emailTemplates"),
  },
  {
    path: "/profile",
    name: "Profile",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/profile/profile"),
  },
  {
    path: "/accounts",
    name: "Account",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/accounts/index"),
  },
  {
    path: "/subAccounts",
    name: "Sub Account",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/accounts/subAccount"),
  },
  {
    path: "/task-sheet",
    name: "Task Sheet",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/task/taskSheet"),
  },
  {
    path: "/create-new-task",
    name: "Create New Task",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/task/createNewTask"),
  },
  {
    path: "/view-task-sheet/:id",
    name: "View Task Sheet",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/task/taskSheetDetails"),
  },
  {
    path: "/cleaning-task",
    name: "Cleaning Task",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/task/cleaningTask"),
  },
  {
    path: "/check-list",
    name: "Check List",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/houseKeeping/checkList"),
  },
  {
    path: "/dnd-reason",
    name: "Dnd Reason",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/houseKeeping/dnd"),
  },
  {
    path: "/discrepancy-reason",
    name: "Discrepancy Reason",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/houseKeeping/discrepancy"),
  },
  {
    path: "/health-questions",
    name: "Health Question",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/houseKeeping/HealthQuestion"),
  },
  {
    path: "/staff-health-question-sheet",
    name: "Staff Health Question Sheet",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/staffHealthSheet/"),
  },
  {
    path: "/mini-bar",
    name: "Mini Bar",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/miniBar/"),
  },
  {
    path: "/staff-shift",
    name: "Staff Shift",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/staffShift/staffShift"),
  },
  {
    path: "/hotel-dashboard",
    name: "Hotel Dashboard",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/hotelDirectory/dashboard"),
  },
  {
    path: "/design-page",
    name: "Design Page",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/hotelDirectory/designPage"),
  },
  {
    path: "/user-review",
    name: "User Review",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/userReview/"),
  },
  {
    path: "/wakeup-call",
    name: "Wakeup Call List",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/wakeUpList/wakeUpList.vue"),
  },
  {
    path: "/inbox",
    name: "Inbox",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/sms/sms.vue"),
  },
  {
    path: "/agent-console",
    name: "Agent Console",
    meta: {
      authRequired: true,
      authorize: true,
    },
    component: () => import("@/views/agentConsole"),
  },
  {
    path: "/rfid-encoder-list",
    name: "RFID Encoder List",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/lock/RFIDEncoderList.vue"),
  },
  {
    path: "/gateway-list",
    name: "Gateway List",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/lock/Gateway"),
  },
  {
    path: "/device-list/:id",
    name: "Device List",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/lock/Device"),
  },
  {
    path: "/room-lock",
    name: "Room Lock",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/lock/RoomLock"),
  },
  {
    path: "/staff-list",
    name: "Staff List",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/lock/StaffList"),
  },
  {
    path: "/staff-group",
    name: "Staff Group",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/lock/StaffGroup"),
  },
  {
    path: "/key-log",
    name: "Key Log",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/lock/KeyLog"),
  },
  {
    path: "/master-slot",
    name: "Master Slot",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/VideoBot/slot/index.vue"),
  },
  {
    path: "/assign-lock",
    name: "Assign Lock",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/lock/StaffGroup"),
  },
  {
    path: "/notification",
    name: "Notification",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/Notification/notification.vue"),
  },

  /** SUPER ADMIN PANEL ROUTES */
  {
    path: "/kiosk-status",
    name: "Kiosk Status",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/kioskStatus/status.vue"),
  },
  {
    path: "/hotel-list",
    name: "Hotel List",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/hotelsList/index.vue"),
  },
  {
    path: "/brand-list",
    name: "Hotel Brands",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/brands/brands.vue"),
  },
  {
    path: "/theme-list",
    name: "Hotel Themes",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/brands/themes.vue"),
  },
  {
    path: "/video-bot",
    name: "Video Bot",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/VideoBot/index.vue"),
  },
  {
    path: "/avatar",
    name: "Avatar",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/VideoBot/avatar/index.vue"),
  },
  {
    path: "/hotel-intent",
    name: "Hotel Intent",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/VideoBot/hotel.vue"),
  },
  {
    path: "/avatar-intent",
    name: "Avatar Intent",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/VideoBot/avatar/intent.vue"),
  },
  {
    path: "/device-model",
    name: "Device Model",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/IOTLock/DeviceModel.vue"),
  },

  {
    path: "/rfid-encoder",
    name: "RFID Encoder",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/IOTLock/RFIDEncoder.vue"),
  },
  {
    path: "/gateway",
    name: "Gateway",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/IOTLock/Gateway.vue"),
  },
  {
    path: "/device",
    name: "Device",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/IOTLock/Device.vue"),
  },
  {
    path: "/hotel-lock-master",
    name: "Lock Master",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/IOTLock/LockMaster.vue"),
  },
  {
    path: "/app-feature",
    name: "App Feature",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/appFeatures/appFeature"),
  },
  {
    path: "/pbx-server",
    name: "pbx-server",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/setting/pbx-server/index.vue"),
  },
  {
    path: "/security-group",
    name: "Security Group",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () =>
      import("@/views/SuperAdmin/setting/security-group/index.vue"),
  },
  {
    path: "/device-profile",
    name: "device-profile",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () =>
      import("@/views/SuperAdmin/setting/device-profile/index.vue"),
  },
  {
    path: "/pbx-ticket-title",
    name: "Pbx Ticket Title",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () =>
      import("@/views/SuperAdmin/setting/pbx-ticket-title/index.vue"),
  },
  {
    path: "/pbx-ticket",
    name: "pbx-ticket",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/pbxTicket/index.vue"),
  },
  {
    path: "/pbx-ticket-detail/:ticketId",
    name: "Pbx Ticket Detail",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/pbxTicket/ticketDetail.vue"),
  },
  {
    path: "/tracking-reports",
    name: "Tracking Reports",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/pbxTicket/trackingReports.vue"),
  },
  {
    path: "/wakeup-calls",
    name: "Wakeup Call",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/wakeup-call"),
  },
  {
    path: "/hotel-admin-user",
    name: "Hotel Admin User",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/user/hotelAdmin.vue"),
  },
  {
    path: "/support-user",
    name: "Support User",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/user/cdxAndPbx.vue"),
  },
  {
    path: "/reseller-user",
    name: "Reseller User",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/user/reseller.vue"),
  },
  {
    path: "/customer-detail",
    name: "Customer Detail",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/customer/detail.vue"),
  },
  {
    path: "/customer-list",
    name: "Customer List",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/customer/index.vue"),
  },
  {
    path: "/notes",
    name: "Notes",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/customer/notes.vue"),
  },
  {
    path: "/domain",
    name: "domain",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/domain/index.vue"),
  },
  {
    path: "/server-health",
    name: "Server Health",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/setting/server-health"),
  },
  {
    path: "/notification-alert",
    name: "Notification Alert",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/setting/notification-alert"),
  },

  {
    path: "/id-scan-desktop",
    name: "ID Scan Desktop",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/IDScan/index.vue"),
  },
  {
    path: "/kiosk-meta",
    name: "Kiosk Meta",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/kiosk/index.vue"),
  },
  {
    path: "/kiosk-meta-tag",
    name: "Kiosk Meta Tag",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/kiosk/tag.vue"),
  },

  /** WEBSITE ROUTES */
  {
    path: "/hotel-register",
    name: "Register Hotel",
    meta: {
      authRequired: true,
      authorize: true,
      layout: Layout,
    },
    component: () => import("@/views/Website/RegisterHotel.vue"),
  },

  /** PAGE NOT FOUND ROUTE */
  {
    path: "/404",
    name: "404",
    component: require("@/views/utility/404").default,
    meta: {
      layout: Layout,
    },
  },

  /** AI BOTS ROUTES */
  {
    path: "/ai-bot/hotel-list",
    name: "ai-bot-hotel-list",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () => import("@/views/SuperAdmin/kioskAI/hotel.vue"),
  },
  {
    path: "/ai-bot/hotel-wise-intent-list",
    name: "ai-bot-hotel-wise-intent-list",
    meta: {
      authRequired: true,
      authorize: true,
      isShow: true,
      layout: Layout,
    },
    component: () =>
      import("@/views/SuperAdmin/kioskAI/hotelWiseIntentList.vue"),
  },

  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },
];
